export const Error = (props) => {
  return (
    <div class="site-width">
      <div class="header-wrapper mb-2 mb-md-3">
        <div class="container-fluid">
          <h1 class="pb-0 mt-1 mt-md-2 mb-1 mb-md-2">Déclaration d'accessibilité</h1>
        </div>
      </div>
      <div class="container-fluid">
        <div class="row">
          <div class="col-12 col-md-10 col-xl-8">
            <div class="alert-container alert-danger mb-2" role="alert">
              <p class="alert">
                <span class="alert-icon icon-error-severe" aria-hidden="true"></span>
                <span class="text-mw">
                  Il y a une erreur dans votre requête (la page n'appartient pas au domaine Orange France ou Sosh), nous ne pouvons pas afficher de déclaration.
                </span>
              </p>
              <div class="alert-content">
                <p class="alert-text">
                  Si vous pensez qu'il s'agit d'un dysfonctionnement, n'hésitez à <a href="mailto:accessibilite.france@orange.com">nous le signaler en nous envoyant un courriel</a>
                  .
                </p>
              </div>
            </div>
            <p>
              Orange s'engage à rendre ses sites internet, intranet, extranet, ses progiciels, ses applications mobiles et mobilier urbain numérique accessibles&nbsp;conformément à
              l'article 47 de la loi n°2005-102 du 11 février 2005.
            </p>
            <p>
              À cette fin,&nbsp;Orange&nbsp;met en œuvre la stratégie et les actions suivantes&nbsp;:{' '}
              <a
                href="https://oran.ge/accessibilite-schema"
                title="schéma pluriannuel d'amélioration de l'accessibilité numérique 2024-2026 (PDF, 230Ko - nouvelle fenêtre)"
                target="_blank"
              >
                Schéma pluriannuel d'amélioration de l'accessibilité numérique 2024-2026 (PDF, 230Ko)
              </a>
              .
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}
